"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.netConnectionAccessors = exports.netConnectionFilterSchema = exports.netAccessors = exports.netFilterSchema = exports.moduleAccessors = exports.moduleFilterSchema = void 0;
const QueryBuilder_1 = require("../QueryBuilder");
exports.moduleFilterSchema = (0, QueryBuilder_1.createFilterSchema)({
    fields: {
        ref: {
            description: 'Module instance id — NOT the reference designator. Filter by `name` when searching for a reference designator like U1 or R3.',
            options: { type: QueryBuilder_1.FieldType.String },
        },
        name: {
            description: 'Reference designator (e.g. U1, R3). This is the human-readable label, not the instance id.',
            options: { type: QueryBuilder_1.FieldType.String },
        },
        designId: {
            description: 'Design containing the module.',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: ['equals', 'is', 'isAnyOf', 'not', 'doesNotEqual'],
        },
        designModelType: {
            description: 'Design model type: "pcb" or "schematic".',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: ['equals', 'is', 'isAnyOf', 'not', 'doesNotEqual'],
        },
        componentRef: {
            description: 'Ref of the component this module is an instance of.',
            options: { type: QueryBuilder_1.FieldType.String },
        },
        componentName: {
            description: 'Name of the component this module is an instance of.',
            options: { type: QueryBuilder_1.FieldType.String },
        },
        componentModelId: {
            description: 'Model ID of the component this module is an instance of.',
            options: { type: QueryBuilder_1.FieldType.String },
        },
        projectModuleName: {
            description: 'Name of the project-level module group this instance belongs to.',
            options: { type: QueryBuilder_1.FieldType.String },
        },
        pinCount: {
            description: 'Number of pins on this module instance.',
            options: { type: QueryBuilder_1.FieldType.Number },
        },
    },
});
exports.moduleAccessors = {
    ref: (e) => e.ref,
    name: (e) => e.name,
    designId: (e) => e.designId,
    designModelType: (e) => e.designModelType,
    componentRef: (e) => e.componentRef,
    componentName: (e) => e.componentName ?? null,
    componentModelId: (e) => e.componentModelId ?? null,
    projectModuleName: (e) => e.projectModuleName,
    pinCount: (e) => e.pinCount,
};
exports.netFilterSchema = (0, QueryBuilder_1.createFilterSchema)({
    fields: {
        name: { description: 'Net name (e.g. VCC, GND, SDA).', options: { type: QueryBuilder_1.FieldType.String } },
        designId: {
            description: 'Design containing a connection on the net. A net can span multiple designs; filter matches any.',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: ['equals', 'is', 'isAnyOf', 'contains'],
        },
        moduleRef: {
            description: 'Connection module ref (instance id) — NOT the reference designator. Matches nets that connect to any module with the given instance id. If you only know the reference designator (e.g. U1), resolve it to a ref via listModules first.',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: ['equals', 'is', 'isAnyOf', 'contains'],
        },
        isGlobal: {
            description: 'True if the net is marked global in at least one design.',
            options: { type: QueryBuilder_1.FieldType.Boolean },
        },
        isHierarchical: {
            description: 'True if the net is marked hierarchical in at least one design.',
            options: { type: QueryBuilder_1.FieldType.Boolean },
        },
        connectionCount: {
            description: 'Total number of (moduleRef, pinRef) connection pairs on the net, deduplicated across designs.',
            options: { type: QueryBuilder_1.FieldType.Number },
        },
    },
});
exports.netAccessors = {
    name: (e) => e.name,
    designId: (e) => e.designIds,
    moduleRef: (e) => e.connections.map((c) => c.moduleRef),
    isGlobal: (e) => e.isGlobal,
    isHierarchical: (e) => e.isHierarchical,
    connectionCount: (e) => e.connectionCount,
};
exports.netConnectionFilterSchema = (0, QueryBuilder_1.createFilterSchema)({
    fields: {
        designId: {
            description: 'Design the connection belongs to.',
            options: { type: QueryBuilder_1.FieldType.String },
            allowedOperators: ['equals', 'is', 'isAnyOf', 'not', 'doesNotEqual'],
        },
        moduleRef: {
            description: 'Module instance id on the connection — NOT the reference designator. If you only know the reference designator (e.g. U1), filter by `moduleName` instead.',
            options: { type: QueryBuilder_1.FieldType.String },
        },
        moduleName: {
            description: 'Reference designator on the connection (e.g. U1, R3).',
            options: { type: QueryBuilder_1.FieldType.String },
        },
        pinRef: {
            description: 'Pin identifier on the module (e.g. 1, 2, VCC, GND).',
            options: { type: QueryBuilder_1.FieldType.String },
        },
    },
});
exports.netConnectionAccessors = {
    designId: (c) => c.designId,
    moduleRef: (c) => c.moduleRef,
    moduleName: (c) => c.moduleName,
    pinRef: (c) => c.pinRef,
};
//# sourceMappingURL=filter-schemas.js.map